import { Routes } from '@angular/router';
import {AuthGuard} from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'catalogos',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/catalogos/catalogos.module').then(m => m.CatalogosModule)
  },
  {
    path: 'configuraciones',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/configuraciones/configuraciones.module').then(m => m.ConfiguracionesModule)
  },
  {
    path: 'empresas',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/empresa/empresa.module').then(m => m.EmpresaModule)
  },
  {
    path: 'negocios',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/negocio/negocio.module').then(m => m.NegocioModule)
  },
  {
    path: 'reportes',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/reportes/reportes.module').then(m => m.ReportesModule)
  },
  {
    path: 'ecommerce',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/ecommerce/ecommerce.module').then(m => m.EcommerceModule)
  },
  {
    path: 'agentes',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/agente/agente.module').then(m => m.AgenteModule)
  },
  { path: '**', redirectTo: 'login' } // Redirigir cualquier otra ruta a login
];
